// extracted by mini-css-extract-plugin
export var closeButton = "_44-3";
export var header = "_44-0";
export var link = "_44-1";
export var retryButton = "_44-2";